module.exports = __webpack_public_path__ + "static/media/how_to_1.e99b7446.svg";